module.exports = __webpack_public_path__ + "static/media/chalkboard_empty.54f6cc90.svg";